import React, { useRef, useEffect, useState } from 'react';
import agenticMesh from '../assets/images/agentic_ai_mesh.png'; // Placeholder, replace with actual mesh/AI image if available

const palette = {
  subtitle: '#702fff',
  title: '#18171b',
  desc: '#222',
  bg: '#fff',
};

const AIMeshShowcase = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [showTitle, setShowTitle] = useState(false);
  const [showDesc, setShowDesc] = useState(false);
  const [showImg, setShowImg] = useState(false);

  // Intersection Observer for scroll-in animation
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Staggered appearance
  useEffect(() => {
    let titleTimeout, descTimeout, imgTimeout;
    if (visible) {
      titleTimeout = setTimeout(() => setShowTitle(true), 200);
      descTimeout = setTimeout(() => setShowDesc(true), 500);
      imgTimeout = setTimeout(() => setShowImg(true), 800);
    }
    return () => {
      clearTimeout(titleTimeout);
      clearTimeout(descTimeout);
      clearTimeout(imgTimeout);
    };
  }, [visible]);

  return (
    <section ref={sectionRef} style={sectionStyles}>
      <div style={headerWrap}>
        <span style={{
          ...subtitle,
          opacity: showTitle ? 1 : 0,
          transform: showTitle ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.7s cubic-bezier(.4,2,.6,1), transform 0.7s cubic-bezier(.4,2,.6,1)'
        }}>AI LAKEHOUSE & DATA AGENTIC MESH</span>
        <h2 style={{
          ...title,
          opacity: showTitle ? 1 : 0,
          transform: showTitle ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.7s cubic-bezier(.4,2,.6,1), transform 0.7s cubic-bezier(.4,2,.6,1)'
        }}>
          Automate Decisions with Agentic AI on Unified, High-Quality Data
        </h2>
        <p style={{
          ...desc,
          opacity: showDesc ? 1 : 0,
          transition: 'opacity 0.7s 0.2s cubic-bezier(.4,2,.6,1)'
        }}>
          The AI Lakehouse Platform unifies and prepares your data for advanced analytics and AI. Our Agentic AI Mesh solution empowers AI agents to reason, automate, and execute business decisions and tasks—leveraging the full context and accuracy of your unified data. This means more reliable, context-aware automation, and smarter, faster outcomes for your business.
        </p>
      </div>
      {/* <div style={imgWrap}>
        <img
            src={agenticMesh}
            alt="AI Lakehouse and Agentic AI Mesh"
          style={{
            ...imgStyles,
            opacity: showImg ? 1 : 0,
            transform: showImg ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 0.9s cubic-bezier(.4,2,.6,1), transform 0.9s cubic-bezier(.4,2,.6,1)'
          }}
        />
      </div> */}
    </section>
  );
};

const sectionStyles = {
  borderRadius: 24,
  margin: '56px auto 0 auto',
  padding: '56px 0 48px 0',
  maxWidth: 1200,
  width: '95%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};
const headerWrap = {
  maxWidth: 900,
  textAlign: 'center',
  margin: '0 auto 40px auto',
};
const subtitle = {
  color: palette.subtitle,
  fontWeight: 700,
  fontSize: 18,
  letterSpacing: 1.5,
  textTransform: 'uppercase',
  marginBottom: 12,
  display: 'inline-block',
  fontFamily: 'Inter, sans-serif',
};
const title = {
  fontSize: 36,
  fontWeight: 400,
  color: palette.title,
  margin: '0 0 18px 0',
  lineHeight: 1.15,
  fontFamily: 'Inter, sans-serif',
};
const desc = {
  color: '#666',
  fontSize: 18,
  fontWeight: 300,
  margin: '0 auto 0 auto',
  maxWidth: 800,
  fontFamily: 'Inter, sans-serif',
  lineHeight: 1.6,
  textAlign: 'center',
};
const imgWrap = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
const imgStyles = {
  width: '100%',
  height: 400, // Reduce height for better fit
  borderRadius: 18,
  marginTop: 24,
  objectFit: 'contain',
};

export default AIMeshShowcase;
